export const pick = (obj = {}, props = []) => {
    return props.reduce((acc, prop) => {
        acc[prop] = obj[prop]
        return acc
    }, {});
}


// WEBPACK FOOTER //
// ./src/utils/object.js